import axios from "axios";

import { ROOT_URL } from "../helper/Config";

export const AUTH_ERROR = "auth_error";
export const FRANCHISE_DATA = "enterprise_data";
//export const RESULT_DATA = "result_data";

export function fetchFranchise(
  token,
  hr = null,
  code = null,
  language,
  callback
) {
  let test_url;
  if (hr === null) {
    test_url = `${ROOT_URL}/franchise/${language}`;
  } else {
    test_url = `${ROOT_URL}/franchise/${language}/${hr}/${code}`;
  }

  return dispatch => {
    return axios
      .get(test_url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        if (response.data.message) {
          callback(response.data.message);
        } else {
          dispatch({
            type: FRANCHISE_DATA,
            payload: response
          });
          //console.log(response);
          callback("success");
        }
      })
      .catch(error => {
        if (error.response) {
          console.log(error.response);
        }
        callback("error");
      });
  };
}

export function saveFranchise(token, data, callback) {
  return dispatch => {
    return axios
      .post(`${ROOT_URL}/franchise`, data, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        //console.log(response);
        if (response.data.score >= 0 && response.data.message === "success") {
          // let groupResult = [];
          // groupResult.push({
          //   name: "column1",
          //   user: response.data.scoreGroup.col1,
          //   average: response.data.averageGroup.col1
          // });
          // groupResult.push({
          //   name: "column2",
          //   user: response.data.scoreGroup.col2,
          //   average: response.data.averageGroup.col2
          // });
          // groupResult.push({
          //   name: "column3",
          //   user: response.data.scoreGroup.col3,
          //   average: response.data.averageGroup.col3
          // });
          // groupResult.push({
          //   name: "column4",
          //   user: response.data.scoreGroup.col4,
          //   average: response.data.averageGroup.col4
          // });
          // groupResult.push({
          //   name: "column5",
          //   user: response.data.scoreGroup.col5,
          //   average: response.data.averageGroup.col5
          // });
          // groupResult.push({
          //   name: "column6",
          //   user: response.data.scoreGroup.col6,
          //   average: response.data.averageGroup.col6
          // });
          // groupResult.push({
          //   name: "column7",
          //   user: response.data.scoreGroup.col7,
          //   average: response.data.averageGroup.col7
          // });
          // groupResult.push({
          //   name: "column8",
          //   user: response.data.scoreGroup.col8,
          //   average: response.data.averageGroup.col8
          // });

          callback(response.data.score, 
            response.data.average,
             response.data.groupResult,
             response.data.scoreGroup,
             response.data.needToImprove,
             response.data.totaltest,
            response.data.newaverage,  
             response.data.globalAverage,
             response.data.totalTestc,
             response.data.globalav,
             response.data.result_id
             );
        } else {
          callback(0, 0, 0);
        }
      })
      .catch(error => {
        if (error.response.status === 401) {
          localStorage.clear();
          dispatch({
            type: AUTH_ERROR,
            payload: error.response.data.message
          });
        }
      });
  };
}
